module.exports = __webpack_public_path__ + "img/logo_sowos_pocket.c67263b2.svg";